module.exports = "https://cdn.redage.net/src/views/player/help/images/arena1.jpg";